import { useQuery } from '@tanstack/react-query';
import { Card } from '@bruno/ui';
import { adminOverview, adminUsage } from '../api/admin';

function dollars(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`;
}

export function OverviewPage() {
  const overview = useQuery({ queryKey: ['admin-overview'], queryFn: adminOverview });
  const usage = useQuery({ queryKey: ['admin-usage', 30], queryFn: () => adminUsage(30) });

  const stat = (label: string, value: string | number) => (
    <Card>
      <div className="text-sm text-slate-500">{label}</div>
      <div className="text-3xl font-semibold mt-1">{value}</div>
    </Card>
  );

  return (
    <div className="flex flex-col gap-6">
      <h1 className="text-2xl font-semibold">Overview</h1>
      <div className="grid grid-cols-1 md:grid-cols-5 gap-3">
        {stat('Users', overview.data?.userCount ?? '—')}
        {stat('Websites', overview.data?.websiteCount ?? '—')}
        {stat('Conversations', overview.data?.conversationCount ?? '—')}
        {stat('Tokens (all-time)', overview.data?.totalTokens?.toLocaleString() ?? '—')}
        {stat('Billed (all-time)', overview.data ? dollars(overview.data.totalCostCents) : '—')}
      </div>

      <Card>
        <h2 className="font-semibold mb-3">Daily usage (last 30 days)</h2>
        {!usage.data || usage.data.stats.length === 0 ? (
          <div className="text-slate-500 text-sm italic">No data yet.</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="text-left text-slate-500 border-b border-slate-200">
                <tr>
                  <th className="py-2">Date</th>
                  <th>Conversations</th>
                  <th>Messages</th>
                  <th>Tokens</th>
                  <th>Cost</th>
                </tr>
              </thead>
              <tbody>
                {usage.data.stats.slice().reverse().map((s) => (
                  <tr key={s.date} className="border-b border-slate-100 last:border-0">
                    <td className="py-1.5">{s.date}</td>
                    <td>{s.conversations}</td>
                    <td>{s.messages}</td>
                    <td>{s.tokens.toLocaleString()}</td>
                    <td>{dollars(s.costCents)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
}
